import E9ToolBarMore from '../ecology9/E9ToolBarMore';

const E8ToolBarMore = (props) => {
    return (
        <div className="e8header-toolbar-more">
            <E9ToolBarMore {...props}/>
        </div>
    );
};

export default E8ToolBarMore;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8ToolBarMore.js